import { deleteQueryParam } from 'www/utils'

function deleteQueryDoctorEquipment() {
  deleteQueryParam('targetDoctorId')
  deleteQueryParam('doctorId')
  deleteQueryParam('equipmentId')
}

export default deleteQueryDoctorEquipment
